import { Link } from '@tanstack/react-router'
import { MenuIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'

import { Menu } from './menu'

export function SheetMenu() {
  return (
    <Sheet>
      <SheetTrigger className="lg:hidden" asChild>
        <Button className="h-8" variant="outline" size="icon">
          <MenuIcon size={20} />
        </Button>
      </SheetTrigger>
      <SheetContent className="flex h-full flex-col px-3 sm:w-72" side="left">
        <SheetHeader>
          <Button
            className="flex w-fit items-center justify-start pb-2 pt-1"
            variant="link"
            asChild
          >
            <Link to="/affiliate" from="/affiliate">
              <SheetTitle className="hidden">Yes Academy</SheetTitle>
              <SheetDescription className="hidden">no-desc</SheetDescription>
              <img
                src="/public/brand-yes.png"
                alt="brand-yes"
                className="h-8"
              />
            </Link>
          </Button>
        </SheetHeader>
        <Menu isOpen />
      </SheetContent>
    </Sheet>
  )
}
